module.exports = __webpack_public_path__ + "TB_Warning_Ambience_B.wav.b4c58a0e.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/warning/TB_Warning_Ambience_B.wav.mp3
// module id = 509
// module chunks = 0